import React from 'react';
import config from '~/config';

const LOADING_STATE_NONE = 'NONE';
const LOADING_STATE_BEGIN = 'BEGIN';
const LOADING_STATE_LOADED = 'LOADED';

const createScript = BaseComponent => {
  class Container extends React.Component {
    state = {
      loadingState: LOADING_STATE_NONE
    }

    componentDidMount() {
      if (this.state.loadingState !== LOADING_STATE_NONE) return;

      this.setState({
        loadingState: LOADING_STATE_BEGIN,
      });

      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.onload = () => {
        this.setState({
          loadingState: LOADING_STATE_LOADED,
        });
      };
      script.src = `https://maps.googleapis.com/maps/api/js?key=${config.mapApiKey}&v=3.exp&libraries=drawing`;
      const head = document.getElementsByTagName('head')[0];
      head.appendChild(script);
    }

    render() {
      if (this.state.loadingState === LOADING_STATE_LOADED) {
        return React.cloneElement(<React.Fragment />, {}, <BaseComponent {...this.props}/>);
      }
      return null;
    }
  }
  return Container;
};

export default createScript;
